import React, { useEffect, useRef } from 'react';
import { doc, setDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../firebase';
import '../App.css'; 

function Call({ roomName, displayName, mentorId }) {
  const jitsiContainerRef = useRef(null);

  useEffect(() => {
    let api = null;

    const loadJitsi = () => {
      if (window.jitsiApi) window.jitsiApi.dispose();

      const domain = 'meet.jit.si';
      const options = {
        roomName,
        parentNode: jitsiContainerRef.current,
        width: '100%',
        height: 600,
        configOverwrite: { disableDeepLinking: true },
        interfaceConfigOverwrite: { SHOW_JITSI_WATERMARK: false },
        userInfo: { displayName }
      };

      api = new window.JitsiMeetExternalAPI(domain, options);
      window.jitsiApi = api;

      setDoc(doc(db, 'activeCalls', mentorId), { inCall: true });

      api.addEventListener('readyToClose', () => {
        api.dispose();
        deleteDoc(doc(db, 'activeCalls', mentorId));
      });
    };

    const script = document.createElement('script');
    script.src = 'https://meet.jit.si/external_api.js';
    script.async = true;
    script.onload = loadJitsi;
    document.body.appendChild(script);

    return () => {
      if (api) api.dispose();
      deleteDoc(doc(db, 'activeCalls', mentorId));
    };
  }, [roomName, displayName, mentorId]);

  return <div ref={jitsiContainerRef} style={{ width: '100%', height: '100vh' }} />;
}

export default Call;
